import { render, staticRenderFns } from "./Game6-6.vue?vue&type=template&id=5eb2ad93&scoped=true&"
import script from "./Game6-6.vue?vue&type=script&lang=js&"
export * from "./Game6-6.vue?vue&type=script&lang=js&"
import style0 from "./Game6-6.vue?vue&type=style&index=0&id=5eb2ad93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb2ad93",
  null
  
)

export default component.exports